/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SigniusAccountStatusDto
 */
export interface SigniusAccountStatusDto {
    /**
     * Whether the user has a linked Signius account
     * @type {boolean}
     * @memberof SigniusAccountStatusDto
     */
    hasAccount: boolean;
    /**
     * Whether the user's identity has been verified for QES
     * @type {boolean}
     * @memberof SigniusAccountStatusDto
     */
    isVerified: boolean;
}

/**
 * Check if a given object implements the SigniusAccountStatusDto interface.
 */
export function instanceOfSigniusAccountStatusDto(value: object): value is SigniusAccountStatusDto {
    if (!('hasAccount' in value) || value['hasAccount'] === undefined) return false;
    if (!('isVerified' in value) || value['isVerified'] === undefined) return false;
    return true;
}

export function SigniusAccountStatusDtoFromJSON(json: any): SigniusAccountStatusDto {
    return SigniusAccountStatusDtoFromJSONTyped(json, false);
}

export function SigniusAccountStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigniusAccountStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'hasAccount': json['hasAccount'],
        'isVerified': json['isVerified'],
    };
}

export function SigniusAccountStatusDtoToJSON(json: any): SigniusAccountStatusDto {
    return SigniusAccountStatusDtoToJSONTyped(json, false);
}

export function SigniusAccountStatusDtoToJSONTyped(value?: SigniusAccountStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasAccount': value['hasAccount'],
        'isVerified': value['isVerified'],
    };
}

